import { render, staticRenderFns } from "./ImageWithLoading.vue?vue&type=template&id=6ad01e9e&lang=pug&"
import script from "./ImageWithLoading.vue?vue&type=script&lang=ts&"
export * from "./ImageWithLoading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAlert,VImg})
